import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import project1 from "../../Assets/Projects/project1.png";
import project2 from "../../Assets/Projects/project2.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project1}
              isBlog={false}
              title="GNSS Vision"
              description="Ứng dụng di động hỗ trợ điều hướng thông minh sử dụng đa cảm biến (GNSS, IMU, và Computer Vision) giúp định vị trong các môi trường đô thị phức tạp. Thiết kế kiến trúc Clean Architecture, tích hợp mô hình AI YOLOv8."
              ghLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project2}
              isBlog={false}
              title="eOffice"
              description="Ứng dụng di động hỗ trợ quản lý văn phòng điện tử, cung cấp giải pháp đa môi trường cho nhiều đối tác (HUST, HMU, HUBT...) được phát triển với cấu trúc Feature-First. Tích hợp SDK của Viettel Mysign và VNPT SmartCA."
              ghLink="#"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
